import axios from '../../services/axios.service';
import { getEndpointBase } from '../../services/api.service';
import { DepartmentFetchParams } from './Department.type';

let listRequest: any = null;

const departmentService = {
  getList: ({ search, page, ...params }: DepartmentFetchParams) => {
    listRequest && listRequest.cancel();
    listRequest = axios.CancelToken.source();
    return axios.get(getEndpointBase(`departments`), {
      cancelToken: listRequest.token,
      params: {
        search,
        page,
        filter: params,
      },
    });
  },
};

export default departmentService;
